<template>
    <v-dialog persistent v-model="dialog" width="80%">
        <!-- <v-card fluid> -->
        <!-- <v-row dense>
            <v-col cols="12">
                Overview accommodations for {{ parkcode }}               
            </v-col>
        </v-row> -->
        <!-- <v-row dense class="mt-3">
            <v-col cols="12"> -->
                <v-card fluid flat class="px-6">
                    <v-card-title>Connect accommodations to {{ park.parkcode }} - {{ park.parkname }} </v-card-title>
                <v-card-text>
                    <v-data-table :headers="getAccoInfoHeaders()" 
                                  :items="acco.info" 
                                  fixed-header :height="wInnerHeight - 300" 
                                  show-select :single-select="false" v-model="toggled_accos"
                                  @item-selected="clickItem" @toggle-select-all="clickAllItems"
                                  item-key="huiscode"
                                  :disable-pagination=true hide-default-footer dense>
                        <template v-slot:body="{ items }" >
                            <tbody>
                                <tr v-for="(item, idx) in items" :key="idx">
                                    <td class="td-style"><v-simple-checkbox dense @click="clickItem()" v-model="item.connected" :disabled="item.disable_toggle"></v-simple-checkbox></td>
                                    <td @click="$router.open('/huis/onHuis/' + item.huis_encrid)" class="image-alignment">
                                        <div class="image-borders">
                                            <v-img :src="item.photo" width="125px" height="100px"></v-img>
                                        </div>
                                    </td>                                    
                                    <td class="td-style">{{ item.huiscode }}</td>
                                    <td class="td-style" align="center">{{ item.status }}</td>                                    
                                    <td class="td-style" align="center">{{ item.huis_aantpers_max }}</td>                                    
                                    <td class="td-style">{{ item.pricing_system }}</td>                                    
                                    <td class="td-style" align="center">{{ item.num_plannings }}</td>                                    
                                    <td class="td-style" align="center">{{ item.num_planningsWithICall }}</td>     
                                    <td class="td-style default-cursor">
                                        <div v-for="regel in item.plannings" v-bind:key="regel.plancode">
                                            <td>{{ regel.plancode }}</td>
                                        </div>
                                    </td>
                                    <td class="td-style default-cursor">
                                        <div v-for="regel in item.plannings" v-bind:key="regel.plancode">
                                            <td>
                                                <span v-if="regel.has_icall"><v-icon small color="success">mdi-check-bold</v-icon></span>
                                                <span v-else><v-icon small color="error">mdi-close</v-icon></span>
                                            </td>
                                        </div>
                                    </td>                                      
                                    <td class="td-style default-cursor">
                                        <div v-for="regel in item.plannings" v-bind:key="regel.plancode">
                                            <td>{{ regel.to_code }}</td>
                                        </div>
                                    </td>
                                    <td class="td-style default-cursor">
                                        <div v-for="regel in item.plannings" v-bind:key="regel.plancode">
                                            <td>{{ regel.to_naam }}</td>
                                        </div>
                                    </td>                              
                                    <td class="td-style">
                                        <div v-if="item.partner_warning"><td><v-icon small color="warning">mdi-alert-outline</v-icon></td></div>
                                        <div v-if="item.partner_warning"><td><v-icon small color="warning">mdi-alert-outline</v-icon></td></div>  
                                    </td>                                                                  
                                    <td class="td-style default-cursor">
                                        <div><td>Booking.com</td></div>
                                        <div><td>AirBnb</td></div>    
                                        <div><td>Vrbo</td></div>
                                        <div><td>Holidu</td></div> 
                                        <div><td>HomeToGo</td></div> 
                                        <div><td>Check24</td></div> 
                                    </td>                
                                    <td class="td-style default-cursor">
                                        <div>
                                            <td>
                                                <span v-if="item.booking"><v-icon small color="success">mdi-check-bold</v-icon></span>
                                                <span v-else><v-icon small>mdi-cancel</v-icon></span>
                                            </td>
                                        </div>
                                        <div>
                                            <td>
                                                <span v-if="item.airbnb"><v-icon small color="success">mdi-check-bold</v-icon></span>
                                                <span v-else><v-icon small>mdi-cancel</v-icon></span>
                                            </td>
                                        </div>
                                        <div>
                                            <td>
                                                <span v-if="item.vrbo"><v-icon small color="success">mdi-check-bold</v-icon></span>
                                                <span v-else><v-icon small>mdi-cancel</v-icon></span>
                                            </td>
                                        </div>
                                        <div>
                                            <td>
                                                <span v-if="item.holidu"><v-icon small color="success">mdi-check-bold</v-icon></span>
                                                <span v-else><v-icon small>mdi-cancel</v-icon></span>
                                            </td>
                                        </div>
                                        <div><td>
                                            <span v-if="item.hometogo2!==0">
                                                <v-icon small :class="`htg${item.hometogo2}`">mdi-check-bold</v-icon>
                                            </span>
                                            <span v-else>
                                                <v-icon small>mdi-cancel</v-icon>
                                            </span>
                                        </td></div>
                                        <div><td>
                                            <span v-if="item.check24!==0">
                                                <v-icon small :class="`htg${item.check24}`">mdi-check-bold</v-icon>
                                            </span>
                                            <span v-else>
                                                <v-icon small>mdi-cancel</v-icon>
                                            </span>
                                        </td></div>                                        
                                    </td>                                                                      
                                </tr>
                            </tbody>
                        </template>
                    </v-data-table>       
                </v-card-text>
            <v-divider  class="ml-2 mr-2"></v-divider>
            <v-card-actions >
                <v-row cols="12" dense class="mt-2 mb-2">

                    <v-spacer></v-spacer>    
                        <v-checkbox dense v-model="set_partners" v-on:input="!set_partners" label="Set partners automatically when possible" class="mr-4"></v-checkbox>   
                <v-btn @click="cancelDialog" color="primary" class="mr-2">
                    cancel
                </v-btn>                  
                <v-btn @click="saveParcData" color="success">
                    connect
                </v-btn>     

                </v-row>
            </v-card-actions>                                 
                </v-card>
            <!-- </v-col>        
        </v-row>   -->
    <!-- </v-card>       -->
    </v-dialog>
</template>

<script>

import mxscreensize from '@/components/js/screensize';

export default {
    components: {
    },
    mixins: [mxscreensize],
    data() {
        return {
            park: {},
            parkcode: '',
            dialog: false,
            acco:{},
            toggled_accos:[],
            set_partners: false
        }
    },
    methods: {
        open(park) {
            this.dialog = true      
            this.park = park       
            this.dialog = true
            this.toggled_accos = []
            this.set_partners = false
            this.getAccoInfo()
        },                    
        closeDialog() {
            this.$emit('reload');
            this.dialog = false;
        },   
        cancelDialog() {
            console.log(this.set_partners)
            this.dialog = false;
        },           
        saveParcData(){
            this.$axios
                .post("ares/json/ares/task/pp/connectAccoToParkv2.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "connectAccos"
                    },
                    connectAccos: {
                       accos: this.toggled_accos,
                       parkcode: this.park.parkcode,
                       partners: this.set_partners
                    }    
                })
                .then(res => {
                    if (res.data.error) {
                        this.showDialog('error', 'Error', res.data.error.message);
                    } else {
                       this.closeDialog()
                    }
                })
        },       
        clickItem(){
            this.loadToggelArray()
        },
        clickAllItems(){
            if (this.toggled_accos.length < this.acco.info.length) {
                this.acco.info.forEach(element => {
                    if(!element.disable_toggle) element.connected = true
                });            
                this.loadToggelArray()
            }    
            else {
                this.acco.info.forEach(element => {
                    if(!element.disable_toggle) element.connected = false
                });   
                this.loadToggelArray()
            }    
        },                
        getAccoInfoHeaders(){
            return [
                { text: " ", sortable: false },
                { text: "Acco", value: "huiscode", sortable: false },
                { text: "St", align: "center", sortable: false, value: "status" },       
                { text: "Pers", sortable: false, value: "huis_aantpers_max" },
                { text: "Prcs", value: "pricing_system", sortable: true, width: "6%" },
                { text: "Plns", value: "num_plannings", sortable: false },
                { text: "+iCall", value: "num_planningsWithICall", sortable: false, align: "center" },
                { text: "plan ", value: "", sortable: false },
                { text: "iCall", sortable: false},                
                { text: "to-code", sortable: false },             
                { text: "to-naam", sortable: false },             
                { text: " ", sortable: false },
                { text: " ", sortable: false },
                { text: " ", sortable: false, width: "1%"},
            ];
        },
        fn(value){
            return new Intl.NumberFormat('nl-NL', {style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2}).format(+value) + '%';
        },
        loadToggelArray(){
            this.toggled_accos = []
            this.acco.info.forEach(element => {
                if(element.connected) this.toggled_accos.push(element)
            });
            //console.log("loaded", this.toggled_accos.length)
        },
        getAccoInfo() {
            this.$axios
                .post("ares/json/ares/task/pp/getParkAccosByEignv2.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getParkAccos"
                    },
                    getParkAccos: this.park
                })
                .then(res => {
                    if (res.data.error) {
                        this.showDialog('error', 'Error', res.data.error.message);
                    } else {
                        this.acco = res.data.getParkAccos;
                        this.loadToggelArray()
                    }
                })
        },
    }
}

</script>

<style scoped>
  .image-borders{
    border-top: 5px solid transparent;
    border-bottom: 5px solid transparent;
  }
  .image-alignment {
    vertical-align: top;
    width: 120px !important;

    /* trick to add padding to a TD element (which is not possible with CSS normally) */
  }
.num{
    align-items: center;
    padding-right: 5px;
}
.table-avatar{
    cursor: pointer;
}
.check-avatar{
    cursor: default;
}
td{
    font-size: 9pt !important;
}
.td-style{
    vertical-align: top !important;
    border-top: 5px solid transparent !important;
}
.default-cursor{
    cursor:default;
  }
  .tiny{
    font-size: 8pt !important;
    font-weight: 300 !important;
    color: black !important;
  }
  .htg1{
    color: orange !important;
  }
  .htg2{
    color: #32B232 !important;
  }
</style>